<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        .fields__element(v-if="user.isSuperadmin || user.isManagerOrSupport || user.type === 'admin'")
            label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_course', 0) }}
            cs-multiselect.fields__input(
                :multiple="true",
                :options="courses",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                hide-selected=true
                :loading="loadingCourses",
                close-on-select=false,
                @open="getCourses",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.courses"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_courseNotFound') }}
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label {{ $i18n.tc('fields.fields_school', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="schools",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingSchools",
                @open="getSchools",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                v-model="form.school"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
        .fields__element(v-if="user.isSuperadmin || user.type !== 'student'")
            label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_grade', 0) }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="grades",
                :show-labels="false",
                label="name",
                track-by="id",
                :searchable="true",
                :loading="loadingGrades",
                :placeholder="gradesPlaceholder",
                v-model="form.grade",
                :disabled="isGradeDisabled",
                @open="getGrades"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
        .fields__element(v-if="user.isSuperadmin || user.isManagerOrSupport || user.type === 'admin'")
            label.fields__label {{ $i18n.t('fields.fields_teacher') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="teachers",
                :show-labels="false",
                track-by="id",
                :searchable="true",
                :loading="loadingTeachers",
                :placeholder="teachersPlaceholder",
                label="fullName",
                v-model="form.teacher",
                :disabled="isTeacherDisabled",
                @open="getTeachers"
            )
                span(slot="noResult") {{ $i18n.t('fields.fields_teacherNotFound') }}
        template(v-if="user.type !== 'student'")
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.t('fields.fields_status') }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="statuses",
                    :show-labels="false",
                    :allow-empty="false",
                    :custom-label="getStatusName",
                    placeholder="",
                    v-model="form.status",
                    :searchable="false"
                )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_sort') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="sort",
                :show-labels="false",
                :placeholder="$i18n.t('fields.fields_sortPlaceholder')",
                :searchable="false",
                track-by="by",
                label="label",
                v-model="form.sort"
            )
        template(v-if="user.type !== 'student'")
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.t('fields.fields_period') }}
                cs-datepicker.fields__input.datepicker-input-container--no-margin(
                    :language="user.locale",
                    :disabled-dates="dateTo ? {from: new Date(dateTo)} : {}",
                    :format="customFormatter",
                    v-model="dateFrom"
                )
                .fields__divider —
                cs-datepicker.fields__input.datepicker-input-container--no-margin(
                    :language="user.locale",
                    :disabled-dates="dateFrom ? {to: new Date(dateFrom)} : {}",
                    :format="customFormatter",
                    v-model="dateTo"
                )
            .fields__element
                .fields__period-buttons-container
                    a.fields__period-button(href="javascript://", @click="setPeriod('day')") {{ $i18n.t('fields.fields_dayPeriod') }}
                    a.fields__period-button(href="javascript://", @click="setPeriod('week')") {{ $i18n.t('fields.fields_weekPeriod') }}
                    a.fields__period-button(href="javascript://", @click="setPeriod('month')") {{ $i18n.t('fields.fields_monthPeriod') }}
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('fields.fields_search') }}
            cs-search-input.fields__input(
                :placeholder="$i18n.t('fields.list_studentPlaceholder')",
                v-model="form.fullName"
                @search="sendForm"
            )
        .fields__element
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../../utils/searchFieldsMixin'
    import {mapState} from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore'
    import statusFieldMixin from '../utils/statusFieldMixin'
    import moment from 'moment'

    export default {
        mixins: [searchFieldsMixin, searchParamsStore, statusFieldMixin],
        data() {
            return {
                sort: [
                    {label: this.$i18n.t('fields.list_sortFirstName'), by: 'first_name'},
                    {label: this.$i18n.t('fields.list_sortLastName'), by: 'last_name'}
                ],
                courses: [],
                schools: [],
                grades: [],
                teachers: [],
                form: {
                    sort: null,
                    courses: null,
                    school: null,
                    grade: null,
                    teacher: null,
                    fullName: null,
                    status: 'active',
                    dateFrom: null,
                    dateTo: null
                },
                dateFrom: null,
                dateTo: null,
            }
        },
        watch: {
            '$route.query' (val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        sort: null,
                        school: null,
                        grade: null,
                        teacher: null,
                        fullName: null,
                        status: 'active',
                        dateFrom: null,
                        dateTo: null
                    };
                }
            },
            'form.sort' () {
                this.updateList()
            },
            'form.school'() {
                this.updateList()
            },
            'form.grade'() {
                this.updateList()
            },
            'form.teacher'() {
                this.updateList()
            },
            'form.fullName'() {
                this.updateList()
            },
            'form.status'() {
                this.updateList()
            },
            'dateFrom'() {
                this.updateList()
            },
            'dateTo'() {
                this.updateList()
            },
        },
        props: ['schoolId', 'gradeId'],
        methods: {
            sendForm() {
                if (this.dateFrom) {
                    this.form.dateFrom = moment(this.dateFrom).format('YYYY-MM-DD');
                }
                if (this.dateTo) {
                    this.form.dateTo = moment(this.dateTo).format('YYYY-MM-DD');
                }
                this.$emit(
                        'search',
                        Object.assign({}, this.form, {
                            sort: _.has(this.form, 'sort.by') ? this.form.sort.by : null
                        })
                );
            },
            resetResults() {
                this.user.isSuperadmin && (this.form.school = null);
                this.form.sort = null;
                this.form.courses = null;
                this.form.grade = null;
                this.form.teacher = null;
                this.form.fullName = null;
                this.resetPeriod();
                this.form.status = 'active';
                this.$emit('search', this.form);
            },
            setPeriod(range) {
                this.dateFrom = moment().startOf(range).format();
                this.dateTo = moment().endOf(range).format();
            },
            resetPeriod() {
                this.dateFrom = null;
                this.form.dateFrom = null;
                this.dateTo = null;
                this.form.dateTo = null;
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            updateList: _.debounce(function() {
                this.sendForm()
            }, 1000)
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/sass/fields/fields.scss";
</style>
